// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"5dc9b085","535":"77299108","886":"b99542de"}[chunkId] + ".chunk.css";
};